import React, { useEffect, useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";

import { regionSagaActions } from "../../Information/Regions";
// import { refSagaActions } from "../../Information/Reference";
import { catalogueSagaActions } from "..";
import { paymentReducerActions } from "../../Payment";

import { Form, Col, Card, Container, Spinner, Row } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { RegionCatalogueCarousel } from "../components/RegionCatalogueCarousel";

import { useSubheader } from "../../../../_metronic/layout";
//import "../css/bootstrap-card-columns.css";

//import cardColStyles from "../css/CardColumn.module.css";

export const RegionCatalogue = (props) => {

  const subheader = useSubheader();
  subheader.setTitle("Goverment Services");

  const dispatch = useDispatch();

  const { region : {entities: regions, totalCount: regionTotalCount, listLoading} } = useSelector((state) => state);
  
  useEffect(() => {
  
    dispatch(regionSagaActions.fetchAllRegions());
    dispatch(catalogueSagaActions.reset());
    dispatch(paymentReducerActions.resetState());
  
  }, [dispatch]);  
  
  const debounceFunction = (func, delay) => {
    
    let timer;
  
    return function() {
      let self = this;
      let args= arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(self, args)
      }, delay)
    }
  };
  
  //use useCallback to memoized or remeber the original function
  const debounceCatalogueSearch = useCallback(
    debounceFunction(
      (nextValue) => {
        let query = { str: nextValue };
        if(nextValue){
          dispatch(regionSagaActions.searchRegions(query));
        } else {
          dispatch(regionSagaActions.fetchAllRegions());
        }
      }, 500
    ), []
  );
  
  
  const handleCatalogueSearch = (event) =>{
    let nextValue = event.target.value;
    debounceCatalogueSearch(nextValue);
  };
  
  return (
    <Card>
      <Card.Header>
        <Row>
            <Col xl={1} sm={12} className="d-flex align-items-start justify-content-center">
              <img alt="dof-logo" src="../media/logos/png-emblem-DOF.png" style={{ display: "inline", width: "100px", borderRadius: "5px"}} />
            </Col>
            <Col xl={11} sm={12} className="d-flex align-items-start justify-content-start">
              <div>
                <h3 className="pt-5"> Welcome to the Department of Finance Online Receipting System </h3> 
                <h6 className="text-muted"> Select the region in which you will be receiving the service. </h6>
              </div>
            </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Container fluid>
          <Row>
            <Col>
              <Form.Group controlId="search">
              <Search size={30} className="pt-3 pl-3" style={{ position: "absolute" }}/>
                  <Form.Control
                    className="pl-10"
                    style={{ fontSize: "16px"}}
                    name="search"
                    placeholder="Search for a region"
                    onChange={handleCatalogueSearch}
                  />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              { 
                listLoading 
                ? <Spinner className="listSpinner" animation="border" /> 
                : ( regionTotalCount <= 0 ? <h5 className="d-flex justify-content-center">No regions found</h5> 
                  : <RegionCatalogueCarousel regions={regions} regionTotalCount={regionTotalCount} /> )
              }
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};
